import React, { useEffect, useState } from "react";
import { useAuth } from "../../../../firebase/AuthProvider";
import DocumentationAnalytics from "../../analytics/DocumentationAnalytics";
import EffortAnalytics from "../../analytics/EffortAnalytics";
import SlaAnalytics from "../../analytics/SlaAnalytics";
import CaseloadAnalytics from "../../analytics/CaseloadAnalytics";
import ParticipantActivityAnalytics from "../../analytics/ParticipantActivityAnalytics";
import TagsAnalytics from "../../analytics/TagsAnalytics";
import "./OwnerDashboard.css";
import { Tab, Nav } from "react-bootstrap";

type TabType = "sla" | "effort" | "documentation" | "caseload" | "activity" | "tags";

const OwnerAnalyticsElement: React.FC = () => {
  const { currentUser } = useAuth();
  const [authToken, setAuthToken] = useState<string>("");
  const [activeTab, setActiveTab] = useState<TabType>("sla");

  useEffect(() => {
    const fetchToken = async () => {
      if (currentUser) {
        const token = await currentUser.getIdToken();
        setAuthToken(token);
      }
    };
    fetchToken();
  }, [currentUser]);

  return (
    <div className="w-full">
      <div className="common_card">
        <Tab.Container
          id="analytics-tabs"
          defaultActiveKey="sla"
          activeKey={activeTab}
          onSelect={(k) => setActiveTab(k as TabType)}
        >
          <div className="d-flex">
            <Nav variant="pills" className="common_tab">
              <Nav.Item>
                <Nav.Link eventKey="sla">SLA</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="effort">Effort</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="documentation">Documentation</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="caseload">Caseload</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="activity">Participant Activity</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="tags">Tags</Nav.Link>
              </Nav.Item>
            </Nav>
          </div>

          <Tab.Content className="common_content_inner mby_t_16">
            <Tab.Pane eventKey="sla">
              {activeTab === "sla" && authToken && (
                <SlaAnalytics authToken={authToken} />
              )}
            </Tab.Pane>
            <Tab.Pane eventKey="effort">
              {activeTab === "effort" && authToken && (
                <EffortAnalytics authToken={authToken} />
              )}
            </Tab.Pane>
            <Tab.Pane eventKey="documentation">
              {activeTab === "documentation" && authToken && (
                <DocumentationAnalytics authToken={authToken} />
              )}
            </Tab.Pane>
            <Tab.Pane eventKey="caseload">
              {activeTab === "caseload" && <CaseloadAnalytics />}
            </Tab.Pane>
            <Tab.Pane eventKey="activity">
              {activeTab === "activity" && <ParticipantActivityAnalytics />}
            </Tab.Pane>
            <Tab.Pane eventKey="tags">
              {activeTab === "tags" && <TagsAnalytics />}
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>
    </div>
  );
};

export default OwnerAnalyticsElement;
